import {Injectable} from '@angular/core';
import {BehaviorSubject, firstValueFrom, map, Observable, of,} from "rxjs";
import {Admission} from './model';
import {OrdsHttpClient} from '../@core/ords-http-client';
import {Router} from "@angular/router";
import {DocumentService, UploadResult} from "../@core/document.service";
import {localhostMode, SessionService} from "../@core/session.service";


import {cloneDeep} from "lodash-es";
import {AimsFile} from '../@formly-aims/formly-field-upload/model';

function customFilter(object: any, result: any): void {
  if (object.hasOwnProperty('uploadStatus') && object.uploadStatus == 'pending')
    result.push(object);
  for (let i = 0; i < Object.keys(object).length; i++) {
    if (typeof object[Object.keys(object)[i]] == "object") {
      customFilter(object[Object.keys(object)[i]], result);
    }
  }
}

@Injectable()
export class AdmissionService {

  private _currentAdm = new BehaviorSubject<Admission | null>(null);

  constructor(private ords: OrdsHttpClient, private router: Router, private docSvr: DocumentService, private sess: SessionService) {
  }

  getPaymentToken(appId: number): Observable<any> {
    return this.ords.post<any>('/payment_info', {'id': appId});
  }

  getActiveAdmissions(): Observable<Admission[]> {
    return this.ords.get<any>('/active_admissions/');
  }

  get currentAdm() {
    return this._currentAdm.getValue()!;
  }

  updateCurrentAdm(admission: Admission) {
    this._currentAdm.next(admission);
  }

  clearCurrentAdm() {
    this._currentAdm.next(null);
  }

  uploadFile(file: any): Observable<string> {
    // TODO - verify doc type and doc size
    if (Object.keys(file).length === 0) {
      return of('');
    }
    if (localhostMode()) {
      throw new Error("Unable to upload document in local host");
    }

    if (!file._raw) {
      return of('');
    }
    return this.docSvr.upload(file._raw).pipe(
      map((res: UploadResult) => (
        res.upld_filex_in_host
      ))
    );
  }

  async upsert(formData: any) {
    const val = cloneDeep(formData);
    delete val['declaration'];
    const docsArr: AimsFile[] = [];
    customFilter(val, docsArr);
    for (let i of docsArr) {
      const path = await firstValueFrom(this.uploadFile(i));
      if (path) {
        i.path = path;
        delete i.uploadStatus;
        delete i._raw;
      }
    }
    val.housing = this.currentAdm.parameters.housing;
    val.origin = this.sess.user?.origin;
    await firstValueFrom(this.ords.post(`/appl/${this.currentAdm.conf_id!}`, val).pipe());
  }

  backToPanel() {
    this.clearCurrentAdm();
    this.router.navigate(['/apply']).then();
  }


}


